/**
 * pipeline/mdc.ts
 *
 * MDC assembly and parsing for the prompt pipeline.
 * Delegates entirely to @pineseed/spec/mdc — no local parsing logic.
 */

import { assembleMdc as assembleRaw } from "@pineseed/spec/mdc";
import type { MdcHeader } from "./types";

export { parseMdcHeader, parseMdcBody } from "@pineseed/spec/mdc";

/**
 * Serialise a typed MdcHeader + markdown body to a .mdc string.
 */
export function assembleMdc(header: MdcHeader, body: string): string {
  return assembleRaw(
    {
      messageId: header.messageId,
      sessionId: header.sessionId,
      references: header.references,
      participant: header.participant,
    },
    body,
  );
}
